export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === '/cs' || to.path.startsWith('/cs/')) {
    const newPath = to.path.replace(/^\/cs/, '')
    return navigateTo(newPath || '/', {
      redirectCode: 301,
    })
  }
})
